module.exports = __webpack_public_path__ + "static/media/brand-refresh-Badge.b34f5d6e.svg";